import React from "react";
import { AnalyticsButton } from "./AnalyticsButton";
import { AnalyticsMap } from "./AnalyticsMap";
import { AnalyticsRouteSelection } from "./AnalyticsRouteSelection";
import { AnalyticsDepotSelection } from "./AnalyticsDepotSelection";
import { AnalyticsChargingSelection } from "./AnalyticsChargingSelection";

export const AnalyticsOperationalRecommendations = ({
  optimizationResults,
  selectedInfoType,
  setSelectedInfoType,
  highlightMapRoute,
  setHighlightMapRoute,
  highlightedDepot,
  setHighlightedDepot,
  highlightedChargingStation,
  setHighlightedChargingStation,
  showUnusedStations,
  setShowUnusedStations,
}) => {

  const renderSelectionList = () => {
    switch (selectedInfoType) {
      case "routes":
        return Object.values(optimizationResults.data.operation.routes).map((route) => (
          <AnalyticsRouteSelection
            key={route.route_id}
            route={route}
            onSelect={setHighlightMapRoute}
            isSelected={highlightMapRoute === route.route_id}
          />
        ));
      case "depots":
        return Object.values(optimizationResults.data.operation.depots).map((depot) => {
          const costData = optimizationResults.data.finance.depot_costs[depot.depot_id] || {};
          const mergedDepot = { ...depot, ...costData };
          return (
            <AnalyticsDepotSelection
              key={depot.depot_id}
              depot={mergedDepot}
              onSelect={setHighlightedDepot}
              isSelected={highlightedDepot === depot.depot_id}
            />
          );
        });
      case "charging":
        return Object.values(optimizationResults.data.operation.charging_stations)
          .filter((station) => showUnusedStations || station.is_utilized)
          .map((station) => {
            const costData = optimizationResults.data.finance.charging_station_costs[station.cs_id] || {};
            const mergedStation = { ...station, ...costData };
            return (
              <AnalyticsChargingSelection
                key={station.cs_id}
                station={mergedStation}
                onSelect={setHighlightedChargingStation}
                isSelected={highlightedChargingStation === station.cs_id}
              />
            );
          });
      default:
        return null;
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md space-y-6">
      <div className="flex justify-center flex-wrap gap-4">
        <AnalyticsButton
          label="Routes"
          handler={() => setSelectedInfoType("routes")}
          isSelected={selectedInfoType === "routes"}
        />
        <AnalyticsButton
          label="Depots"
          handler={() => setSelectedInfoType("depots")}
          isSelected={selectedInfoType === "depots"}
        />
        <AnalyticsButton
          label="Public Chargers"
          handler={() => setSelectedInfoType("charging")}
          isSelected={selectedInfoType === "charging"}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1 bg-gray-50 p-4 rounded-lg border max-h-[600px] overflow-y-auto">
          <h4 className="font-semibold font-nunito text-lg text-gray-700 mb-4 text-center">
            {selectedInfoType === "routes" ? "Select a Route" :
             selectedInfoType === "depots" ? "Select a Depot" :
             "Select a Charging Station"}
          </h4>
          <div className="space-y-3">
            {renderSelectionList()}
          </div>
        </div>

        <div className="lg:col-span-2 min-h-[600px] rounded-lg overflow-hidden">
          <AnalyticsMap
            routes={optimizationResults.data.operation.routes}
            selectedRouteId={highlightMapRoute}
            depots={optimizationResults.data.operation.depots}
            selectedDepot={highlightedDepot}
            chargingStations={optimizationResults.data.operation.charging_stations}
            selectedChargingStation={highlightedChargingStation}
          />
        </div>
      </div>

      {selectedInfoType === "charging" && (
        <div className="flex items-center justify-center pt-4 border-t mt-4">
          <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
            <input
              type="checkbox"
              checked={showUnusedStations}
              onChange={() => setShowUnusedStations(!showUnusedStations)}
              className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <span className="font-nunito">Show all available charging stations</span>
          </label>
        </div>
      )}
    </div>
  );
}; 